import SideBanners from "./SideBanners";

export default SideBanners;
